import { Disclosure } from '@headlessui/react'
import { ChevronDownIcon } from '@ordr-as/icons'
import React from 'react'

type Props = {
    title: string
    defaultOpen?: boolean
    children: React.ReactNode
}

const CollapsiblePanel = ({ title, defaultOpen = false, children }: Props) => {
    return (
        <Disclosure defaultOpen={defaultOpen}>
            {({ open }) => (
                <div className="rounded-lg bg-brand-white shadow-lg">
                    <Disclosure.Button className="w-full flex justify-between items-center px-4 py-4 text-left text-lg font-semibold text-brand-black">
                        <h2 className="text-lg font-semibold">{title}</h2>
                        <ChevronDownIcon
                            className={`h-5 w-5 transition-transform duration-200 ${open ? 'rotate-180' : ''}`}
                        />
                    </Disclosure.Button>

                    <Disclosure.Panel className="px-4 pb-6 pt-2 text-sm leading-relaxed space-y-4">
                        {children}
                    </Disclosure.Panel>
                </div>
            )}
        </Disclosure>
    )
}

export default CollapsiblePanel
